// Libs
import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';
// Others
import authReducer from '~/thunks/auth/authSlice';
import customerReducer from '~/thunks/customer/customerSlice';
import folderReducer from '~/thunks/folder/folderSlice';
import documentReducer from '~/thunks/document/documentSlice';
import employeeReducer from '~/thunks/employee/employeeSlice';
import jobReducer from '~/thunks/job/jobSlice';
import contactReducer from '~/thunks/contact/contactSlice';
import scheduleReducer from '~/thunks/schedule/scheduleSlice';
import activityReducer from '~/thunks/activity/activitySlice';
import userReducer from '~/thunks/user/userSlice';
import notesReducer from '~/thunks/notes/notesSlice';
import taskReducer from '~/thunks/task/taskSlice';
import serviceReducer from '~/thunks/service/serviceSlice';
import materialReducer from '~/thunks/material/materialSlice';
import priceBookReducer from '~/thunks/priceBook/priceBookSlice';
import conversationReducer from '~/thunks/conversation/conversationSlice';
import statisticReducer from '~/thunks/statistic/statisticSlice';
import estimateTemplateReducer from '~/thunks/estimateTemplate/estimateTemplateSlice';
import campaignReducer from '~/thunks/campaign/campaignSlice';
import estimateReducer from '~/thunks/estimate/estimateSlice';
import timeClockReducer from '~/thunks/timeClock/timeClockSlice';
import notificationReducer from '~/thunks/notification/notificationSlice';
import categoryReducer from '~/thunks/category/categorySlice';
import masterDataReducer from '~/thunks/masterData/masterDataSlice';
import fileReducer from '~/thunks/file/fileSlice';
import invoiceReducer from '~/thunks/invoice/invoiceSlice';
import quickBooksReducer from '~/thunks/quickBooks/quickBooksSlice';
import poReducer from '~/thunks/po/poSlice';
import reviewReducer from '~/thunks/review/reviewSlice';
import googleReducer from '~/thunks/google/googleSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  customer: customerReducer,
  job: jobReducer,
  employee: employeeReducer,
  folder: folderReducer,
  document: documentReducer,
  file: fileReducer,
  contact: contactReducer,
  schedule: scheduleReducer,
  activity: activityReducer,
  user: userReducer,
  notes: notesReducer,
  task: taskReducer,
  service: serviceReducer,
  material: materialReducer,
  priceBook: priceBookReducer,
  conversation: conversationReducer,
  statistic: statisticReducer,
  estimateTemplate: estimateTemplateReducer,
  campaign: campaignReducer,
  estimate: estimateReducer,
  timeClock: timeClockReducer,
  notification: notificationReducer,
  category: categoryReducer,
  masterData: masterDataReducer,
  invoice: invoiceReducer,
  quickBooks: quickBooksReducer,
  po: poReducer,
  review: reviewReducer,
  google: googleReducer,
});

export function makeStore() {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
    devTools: process.env.NODE_ENV !== 'production',
  });
}

const store = makeStore();

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export default store;
